export default __webpack_public_path__ + "static/media/chat.c49db838.svg";